import './_fitment-config.scss';

const API_ENDPOINT = 'https://fitmentapi.azurewebsites.net/api/serenity-ymm';
const FITMENT_SHOP_BUTTON = document.querySelector('.fitment_shop_btn');
const FITMENT_CLEAR_BUTTON = document.querySelector('.fitment_clear_btn');

let vehicleTypes;
let currentSelectedVehicle = localStorage.getItem('fitment') ? JSON.parse(localStorage.getItem('fitment')) : {};
let sectionVehicleType;

async function processFitments(currentSelectedVehicle) {
    let param = '';

    for (const [k, v] of Object.entries(currentSelectedVehicle)) {
        const data = await getFitments(param);
        if (Object.keys(data.result).length > 0 && Object.keys(data.result)[0] !== 'sku') {
            makeFitmentSelect(Object.keys(data.result)[0], data.result[Object.keys(data.result)[0]], v);
        }
        param += '&' + k + '=' + v;
    }

    FITMENT_SHOP_BUTTON.removeAttribute('disabled');

    if (Object.keys(currentSelectedVehicle).length) {
        FITMENT_CLEAR_BUTTON.style.display = 'block';
    }
}

async function getFitments(param) {
    let json;
    document.getElementById('fitment-btn-text').style.display = 'none';
    document.getElementById('fitment-loading').classList.add('fitment-loading--active');

    try {
        const response = await fetch(`${API_ENDPOINT}?vehicle_type=${sectionVehicleType.name}${param.length ? `&${param}` : ''}`);
        json = await response.json();
    } catch (error) {
        document.getElementById('fitment-loading').classList.remove('fitment-loading--active');
        document.getElementById('fitment-error').classList.add('fitment-error--active');
        document.getElementById('fitment-btn-text').style.display = 'block';
    }

    if (json) {
        document.getElementById('fitment-loading').classList.remove('fitment-loading--active');
        document.getElementById('fitment-btn-text').style.display = 'block';
        return json;
    }
}

function removeDuplicates(arr) {
    const uniqueLowercaseValues = [];
    const filteredArray = [];

    arr.forEach((item) => {
        const lowercaseItem = item.toString().toUpperCase();

        if (!uniqueLowercaseValues.includes(lowercaseItem)) {
            uniqueLowercaseValues.push(lowercaseItem);
            filteredArray.push(item);
        }
    });

    return filteredArray;
}

function makeFitmentSelect(id, optionArray, v) {
    if (id === 'year') {
        optionArray = optionArray.reverse();
    }

    const filteredOptions = removeDuplicates(optionArray);
    
    if (filteredOptions.length > 0) {
        const selectElement = document.getElementById(id);
        if (id === 'year' || id === 'make' || id === 'model') {
            let html = '';
            filteredOptions.forEach(option => {
                if (id === 'year') {
                    html += '<option class="fitment_option" ' + (option == parseInt(v) ? 'selected' : '') + '>' + option + '</option>';
                } else {
                    html += '<option class="fitment_option" ' + (option === v ? 'selected' : '') + '>' + option + '</option>';
                }
            });
            selectElement.innerHTML += html; 
            selectElement.removeAttribute('disabled'); 
        } else {
            let html = '<select id="' + id + '" class="fitment_select select__select">' +
                '<option selected hidden>' + (id === 'drive_type' ? 'Drive Type' : (id === 'fuel_type' ? 'Fuel Type' : id.charAt(0).toUpperCase() + id.slice(1))) + '</option>';
            filteredOptions.forEach(option => {
                html += '<option class="fitment_option" ' + (option === v ? 'selected' : '') + '>' + option + '</option>';
            });
            html += '</select>';
            document.querySelector('.fitment-select__container').insertAdjacentHTML('beforeend', html);
        }
    }
}

function makeFitmentParam(type) {
    let param = ''; 
    let isAdding = true;
    let keyArray = [];

    for (let k in currentSelectedVehicle) {
        let v = currentSelectedVehicle[k];
        if (isAdding) {
            param += k + '=' + v + '&';
            keyArray.push(k);
        } else {
            delete currentSelectedVehicle[k];
        }
        if (k == type) {  
            isAdding = false;
        }
    }

    document.querySelectorAll('.fitment_select').forEach(element => {
        if (!keyArray.includes(element.id)) {  
            let id = element.id;  
            
            if (id === 'year' || id === 'make' || id === 'model') {
                let options = document.querySelectorAll('#' + id + ' option.fitment_option');
                options.forEach(option => {
                    option.remove();
                });
    
                element.disabled = true;
            } else {
                element.remove();
            }
        }
    });

    return param.slice(0, -1);
}

document.addEventListener('change', function(event) {
    const target = event.target; 
    const validSelectArr = ['vehicle_type', 'year', 'make', 'model', 'submodel', 'drive_type', 'fuel_type', 'doors', 'type', 'position', ];

    if (target.classList.contains('fitment_select') && validSelectArr.includes(target.id)) {
        currentSelectedVehicle[target.id] = target.value;

        getFitments(makeFitmentParam(target.id)).then(data => {
            if (Object.keys(data.result).length > 0 && Object.keys(data.result)[0] !== 'sku' && data.result[Object.keys(data.result)[0]].length > 0) {
                makeFitmentSelect(Object.keys(data.result)[0], data.result[Object.keys(data.result)[0]]);
                FITMENT_SHOP_BUTTON.setAttribute('disabled', '');
            } else {
                FITMENT_SHOP_BUTTON.removeAttribute('disabled');
            }
        });
    }
});


if (FITMENT_SHOP_BUTTON) {
    FITMENT_SHOP_BUTTON.addEventListener('click', function() {
        localStorage.setItem('fitment', JSON.stringify(currentSelectedVehicle));
        localStorage.setItem('current_fitment', sectionVehicleType.name);
        
        if (!document.URL.includes('/collections/') && !document.URL.includes('/products/') && !document.URL.includes('search?q=')) {
            window.location.href = sectionVehicleType.route;
        } else if (document.URL.includes('collections') || document.URL.includes('search?q=')) {
            const baseUrl = window.location.origin + window.location.pathname
            window.history.replaceState({}, document.title, baseUrl);
            window.location.href = baseUrl;
        }
    });
}

if (FITMENT_CLEAR_BUTTON) {
    FITMENT_CLEAR_BUTTON.addEventListener('click', function () {
        currentSelectedVehicle = {};
        localStorage.removeItem('fitment');
        
        document.querySelectorAll('.fitment_select').forEach(element => {
            let id = element.id;
        
            if (id === 'year' || id === 'make' || id === 'model') {
                element.querySelectorAll('option.fitment_option').forEach(option => {
                    option.remove();
                });
                
                element.disabled = true;
            } else {
                element.remove();
            }
        });
        
        getFitments('').then((data) => {
            if (Object.keys(data.result).length > 0) {
                makeFitmentSelect(Object.keys(data.result)[0], data.result.year);
            }
        });
        FITMENT_SHOP_BUTTON.setAttribute('disabled', '');
        FITMENT_CLEAR_BUTTON.style.display = 'none';

        window.location.reload();
    });
}

document.addEventListener('DOMContentLoaded', () => {
    const fitmentConfigSection = document.querySelector('.fitment-config');

    if (fitmentConfigSection) {
        const vehicleTypeString = fitmentConfigSection.dataset.fitmentCollections;
        
        vehicleTypes = vehicleTypeString.split(';').map((type) => {
            type = type.split('|');

            return {
                name: type[0],
                handle: type[1],
                route: `/collections/${type[1]}`,
            };
        });

        sectionVehicleType = vehicleTypes.find((vt) => {
            return vt.name.toLowerCase() === fitmentConfigSection.dataset.vehicleType.toLowerCase() && vt.handle === fitmentConfigSection.dataset.selectedCollectionHandle;
        });

        if (Object.keys(currentSelectedVehicle).length && sectionVehicleType.name === localStorage.getItem('current_fitment')) {
            processFitments(currentSelectedVehicle);
        } else {
            localStorage.removeItem('fitment');
            localStorage.removeItem('current_fitment');

            getFitments('').then((data) => {
                if (Object.keys(data.result).length > 0) {
                    makeFitmentSelect(Object.keys(data.result)[0], data.result.year);
                }
            });   
        }
    }
});